import { render, staticRenderFns } from "./InsCmsList.vue?vue&type=template&id=27fb0672&scoped=true"
import script from "./InsCmsList.vue?vue&type=script&lang=ts"
export * from "./InsCmsList.vue?vue&type=script&lang=ts"
import style0 from "./InsCmsList.vue?vue&type=style&index=0&id=27fb0672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb0672",
  null
  
)

export default component.exports